// Keep in sync with the manual Add Nominee form (new-employee-portal-ui) and
// options-backend's Excel template + upload validators — nominee and guardian
// relationship share this same option set.
export const NOMINEE_RELATIONSHIP_OPTIONS = [
  "Wife",
  "Husband",
  "Son",
  "Daughter",
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Other",
];
